import styled, { css } from 'styled-components';
import { Typography } from '../../../global/theme';
import { mobile_s, mobile_xl } from '../../../global/mediaQueryMixin';
import { AlignCenter, FlexBetween } from '../../../global/commonStyle';

const ModalBox = styled.div`
  padding: var(--space-20);
  ${AlignCenter}
  flex-direction: column;
  gap: var(--space-20);
  position: relative;
  .closeIcon {
    position: absolute;
    top: 10px;
    right: 10px;
  }
`;

const TitleDiv = styled.div`
  ${AlignCenter}
  flex-direction: column;
  gap: var(--space-8);
  max-width: 380px;
  width: 100%;
`;

const Title = styled.div`
  ${Typography.heading_md}
  color: var(--text-primary);
`;

const Description = styled.div`
  ${Typography.body_md}
  text-align: center;
  color: var(--text-secondary);
  max-width: 300px;
`;
const Bottom = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-8);
`;
const BottomText = styled.div`
  ${Typography.body_md}
  text-align: left;
  color: var(--text-primary);
`;
const Link = styled.div`
  ${FlexBetween}
  gap: var(--space-12);
`;

const LinkText = styled.div`
  ${Typography.body_md}
  text-align: left;
  color: var(--text-secondary);
  max-width: 282px;
  width: 100%;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  ${mobile_xl(css`
    max-width: 200px;
  `)}
  ${mobile_s(css`
    max-width: 142px;
  `)}
`;

const BottomBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-12);
  width: 100%;
`;
const Line = styled.div`
  border-top: 0.5px solid var(--border-primary);
`;
export { ModalBox, Title, Description, TitleDiv, Bottom, BottomText, Link, LinkText, BottomBox, Line };
